export default {
  name: 'TranslationsDomElement',
  props: ['value'],
  computed: {
    elements () {
      if (this.value) {
        const parts = this.value.split('|');
        const res = [];
        const totalParts = parts.length;
        for (let i = 0; i < totalParts; i += 2) {
          if (i > 0 && parts[i - 1] && parts[i - 1] === 'BR') {
            res.push({ class: 'BR', text: '' });
            res.push({ text: parts[i] });
          } else {
            const item = { text: parts[i] };
            if (i > 0 && parts[i - 1]) {
              item.class = 'text-' + parts[i - 1];
            }
            res.push(item);
          }
        }
        return res;
      }
    }
  }
}
